export const colors = {
  primary: {
    main: '#3B9CD6',
    light: '#C2E0F2',
    dark: '#19425A',

    primary_50: "#ebf5fb",
  }
};